/**
 * BADU — "Buy now"
 *
 * Shopify's dynamic checkout button carries a label the store's wallet
 * providers decide ("Pay with PayPal" here), which no theme setting can
 * change. This is the same journey under a label we control: add the selected
 * variant to the cart, then go straight to checkout.
 *
 * Reads the variant and quantity from the product form the button sits in, so
 * it always follows the variant picker rather than assuming the default.
 */
(function () {
  const SELECTOR = '[data-badu-buy-now]';
  const BUSY_CLASS = 'is-busy';

  function findForm(button) {
    // The button sits outside <form> in some layouts, so fall back to the
    // nearest product-information container.
    return (
      button.closest('form[action*="/cart/add"]') ||
      button.closest('.shopify-section, product-form-component')?.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function readSelection(form) {
    if (!form) return null;
    const data = new FormData(form);
    const id = data.get('id');
    if (!id) return null;
    const quantity = Number(data.get('quantity')) || 1;

    const payload = { items: [{ id: Number(id), quantity }] };

    // Carry line item properties (engraving, gift note) if the form has any.
    const properties = {};
    for (const [key, value] of data.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    }
    if (Object.keys(properties).length > 0) payload.items[0].properties = properties;

    const sellingPlan = data.get('selling_plan');
    if (sellingPlan) payload.items[0].selling_plan = Number(sellingPlan);

    return payload;
  }

  async function buyNow(button) {
    if (button.classList.contains(BUSY_CLASS)) return;

    const form = findForm(button);
    const payload = readSelection(form);

    if (!payload) {
      // No variant resolved — let the normal add-to-cart path surface the
      // reason rather than failing silently here.
      form?.querySelector('[type="submit"]')?.click();
      return;
    }

    button.classList.add(BUSY_CLASS);
    button.setAttribute('aria-busy', 'true');

    try {
      const routes = window.Theme?.routes || {};
      const response = await fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error(`add to cart failed: ${response.status}`);

      window.location.href = '/checkout';
    } catch (error) {
      console.error('[badu-buy-now]', error);
      button.classList.remove(BUSY_CLASS);
      button.removeAttribute('aria-busy');
      // Fall back to the standard add-to-cart so the shopper is never stuck.
      form?.querySelector('[type="submit"]')?.click();
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(SELECTOR);
    if (!button || button.disabled) return;
    event.preventDefault();
    buyNow(button);
  });
})();
